<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="Edit One Off Fee"
      maxWidth="800px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-row class="mt-3">
          <v-col cols="12">
            <SimplePageHeader title="Assignment"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Consultant"
              v-bind:value="userName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              label="Client"
              v-bind:value="clientName"
              readonly
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <SimplePageHeader title="Fee"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-form ref="OneOffFeeEditForm">
          <v-row class="mt-3">
            <v-col cols="12" sm="8">
              <v-text-field
                label="Description"
                v-model="descriptionValue"
                validate-on-blur
                :rules="[required('Description')]"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <SimpleDatePicker
                :label="'Date'"
                :value="dateValue"
                :isRequired="true"
                @selected-date-change="dateChangeHandler"
              ></SimpleDatePicker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <FormattedNumberField
                label="Pay Amount"
                :value="payAmountValue"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.payAmountValue = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <FormattedNumberField
                label="Bill Amount"
                :value="billAmountValue"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.billAmountValue = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="notesValue"
                label="Notes"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="editOneOffFee"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import SimplePageHeader from '@/components/pageComponents/SimplePageHeader'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import required from '@/lib/formValidations/required'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    SimpleDatePicker,
    FormattedNumberField
  },
  props: [
    'assignmentId',
    'userName',
    'clientName',
    'id',
    'description',
    'payAmount',
    'billAmount',
    'date',
    'notes'
  ],
  data () {
    return {
      showModalProp: false
    }
  },
  computed: {
    descriptionValue: {
      get () {
        return this.description
      },
      set (newValue) {
        this.$emit('descriptionChange', newValue)
      }
    },
    payAmountValue: {
      get () {
        return this.payAmount
      },
      set (newValue) {
        this.$emit('payAmountChange', newValue)
      }
    },
    billAmountValue: {
      get () {
        return this.billAmount
      },
      set (newValue) {
        this.$emit('billAmountChange', newValue)
      }
    },
    dateValue: {
      get () {
        return this.date
      },
      set (newValue) {
        this.$emit('dateChange', newValue)
      }
    },
    notesValue: {
      get () {
        return this.notes
      },
      set (newValue) {
        this.$emit('notesChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('oneOffFeesRecords', ['updateOneOffFee']),
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.clearFee()
      this.$refs.OneOffFeeEditForm.resetValidation()
      this.showModalProp = false
      this.$emit('closeModal')
    },
    async editOneOffFee () {
      if (this.$refs.OneOffFeeEditForm.validate()) {
        await this.updateOneOffFee(Object.assign({}, {
          id: this.id,
          assignmentId: this.assignmentId,
          description: this.description,
          payAmount: this.payAmount,
          billAmount: this.billAmount,
          date: this.date,
          notes: this.notes
        }))
        this.closeModal()
      }
    },
    dateChangeHandler (newDate) {
      this.dateValue = newDate
    },
    clearFee () {
      this.descriptionValue = null
      this.payAmountValue = null
      this.billAmountValue = null
      this.dateValue = null
      this.notesValue = null
      this.$refs.OneOffFeeEditForm.resetValidation()
    },
    required
  }
}
</script>
